import { render, staticRenderFns } from "./ExpandableDiv.vue?vue&type=template&id=05dd4afc&"
import script from "./ExpandableDiv.vue?vue&type=script&lang=js&"
export * from "./ExpandableDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports